module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_is-object.js
// module id = ../node_modules/core-js/modules/_is-object.js
// module chunks = 1